import Proxy from '../Proxy';

class UserProxy extends Proxy {
  /**
   * The constructor for the ArtistProxy.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('users', parameters);
  }

  deleted() {
    return this.submit('get', `${this.endpoint}/deleted`);
  }

  restore(uuid) {
    return this.submit('put', `/${this.endpoint}/${uuid}/restore`);
  }
}

export default UserProxy;
